"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyChartOpenSchedulingWidget = void 0;
const validation_1 = require("./validation");
const react_1 = __importDefault(require("react"));
const utilities_1 = require("./utilities");
const ConfigurationIssues_1 = require("../ConfigurationIssues/ConfigurationIssues");
const styles_1 = require("./styles");
const card_container_1 = __importDefault(require("../CardContainer/card-container"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../lib/messages"));
function MyChartOpenSchedulingWidget(props) {
    var _a;
    const openSchedulingConfig = props.openSchedulingConfig;
    if (!((_a = openSchedulingConfig === null || openSchedulingConfig === void 0 ? void 0 : openSchedulingConfig.enabled) !== null && _a !== void 0 ? _a : false)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const openSchedulingConfigValidationIssues = [];
    if (!(0, validation_1.validateMyChartOpenSchedulingConfiguration)(openSchedulingConfig, openSchedulingConfigValidationIssues)) {
        return (react_1.default.createElement(ConfigurationIssues_1.ConfigurationIssues, { issues: openSchedulingConfigValidationIssues }));
    }
    const visitTypes = (0, utilities_1.getVisitTypesFromProviderForOpenScheduling)(openSchedulingConfig, props.provider);
    const providerId = (0, utilities_1.getProviderIdForOpenScheduling)(props.provider);
    if (!providerId) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const options = {
        url: openSchedulingConfig.url,
        apiKey: openSchedulingConfig.api_key,
        widgetId: openSchedulingConfig.widget_id,
        providerId,
        visitTypes
    };
    if (openSchedulingConfig.overrides) {
        options.overrides = (0, utilities_1.convertOverrides)(openSchedulingConfig.overrides);
    }
    const embeddedUrl = (0, utilities_1.buildMyChartOpenSchedulingWidgetUrl)(options);
    return (react_1.default.createElement("section", { "aria-labelledby": "ProviderAppointmentsHeading" },
        react_1.default.createElement(card_container_1.default, null,
            react_1.default.createElement(styles_1.AppointmentsHeading, { id: "ProviderAppointmentsHeading" }, props.intl.formatMessage(messages_1.default.profileAppointmentsHeader)),
            react_1.default.createElement("section", { "aria-label": props.intl.formatMessage(messages_1.default.openSchedulingWidgetLabel) },
                react_1.default.createElement(styles_1.OpenSchedulingIFrame, { src: embeddedUrl })))));
}
const MyChartOpenSchedulingEmbeddedWithIntl = (0, intl_1.injectIntl)(MyChartOpenSchedulingWidget);
exports.MyChartOpenSchedulingWidget = MyChartOpenSchedulingEmbeddedWithIntl;
//# sourceMappingURL=OpenSchedulingWidget.js.map